<template>
  <div class="h-select" :class="[size, optionsShow ? 'dropdown' : '']">
    <div class="h-select-option-bar h-bg brown-2" v-click-sound-button @click="handleToggleShow">
      <div class="text" :class="{empty: !selectedText}" :title="selectedText || placeholder">
        {{ selectedText || placeholder}}
      </div>
      <button class="h-button SCNRBDNN_BR"></button>
    </div>
    <div class="h-select-options h-bg brown-2 scrollbar"
         :style="optionsStyle"
         v-show="optionsShow">
      <div v-for="item in options"
           class="option-item h-outer-border around-4 bw1 bz0 ls-1 white"
           v-click-sound-button
           @click="handleSelect(item)">
        <div class="icon" v-if="item.icon">
          <img :src="item.icon" alt="">
        </div>
        <div class="text">{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'h-select',

    beforeDestroy () {
      document.removeEventListener('click', this.handleDocClick)
    },

    data () {
      return {
        optionsShow: false,
      }
    },

    props: {
      options: {
        type: Array,
        default () {
          return []
        }
      },
      value: null,
      size: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      optionWidth: {
        type: String,
        default: '100%'
      },
      optionsMaxHeight: {
        type: String,
        default: ''
      },
      triggerOnlyArrowButton: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      selectedText () {
        const option = this.options.find((opt) => opt.value === this.value)
        return String(option?.text || '')
      },

      optionsStyle () {
        return `width: ${this.optionWidth}; max-height: ${this.optionsMaxHeight};`
      },
    },

    mounted () {
      document.addEventListener('click', this.handleDocClick)
    },

    methods: {
      handleDocClick (e) {
        if (this.optionsShow && !this.$el.contains(e.target)) {
          this.optionsShow = false
        }
      },

      clear () {
        this.$emit('input')
      },

      hideOptions () {
        this.optionsShow = false
      },

      handleToggleShow () {
        if (this.triggerOnlyArrowButton) {
          return
        }
        if (!this.options.length && !this.optionsShow) {
          return
        }
        this.optionsShow = !this.optionsShow

        if (this.optionsShow) {
          this.$emit('optionsShow')
        }
      },

      handleSelect (item) {
        this.optionsShow = false
        this.$emit('input', item.value)
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .h-select.large
    .h-select-option-bar
      line-height 26px
      font-size 14px
      .text
        height 26px
        line-height 26px
      .h-button
        flex-shrink 0
        width 26px
        height 26px
    .h-select-options
      top 32px

  .h-select
    position relative
    &.dropdown
      .h-select-option-bar
        border 1px solid #f0e480
        outline 1px solid #c8a848
        box-shadow 2px 2px 0 #000

  .h-select-option-bar
    position relative
    z-index 1
    display flex
    align-items center
    width 100%
    padding 1px
    line-height 20px
    font-size 12px
    border 1px solid #e0d0a8
    outline 1px solid #655832
    color #fffborder
    background-color #000
    .text
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
      width calc(100% - 20px)
      padding 0 2px
      height 20px
      line-height 20px
      letter-spacing 1px
      transform-origin center
      transform scale(0.917)
      text-align center
      whiteText1()
      &.empty
        color rgba(255, 255, 255, 0.55)
    .h-button
      flex-shrink 0
      width 20px
      height 20px
      cursor pointer

  .h-select-options
    position absolute
    z-index 2
    right 0
    top 26px
    border 1px solid #f0e480
    box-shadow 2px 2px 0 #000
    overflow-y auto
    .option-item
      display flex
      align-items center
      padding 2px 4px
      line-height 24px
      cursor pointer
      .icon
        overflow hidden
        display flex
        align-items center
        justify-content center
        margin-right 5px
        flex-shrink 0
        width 22px
        height 22px
        img
          max-width 100%
      .text
        font-size 12px
      &:hover
        color $colorGold
        background-color rgba(0, 0, 0, 0.3)
      &:active
        color $colorGold
        background-color rgba(0, 0, 0, 0.5)

</style>
